// extracted by mini-css-extract-plugin
export default {"AlcoholWarning":"AlcoholWarning_AlcoholWarning__TbG0d","AlcoholWarning__title":"AlcoholWarning_AlcoholWarning__title__Ejpep"};